module.exports = __webpack_public_path__ + "img/addtohome.a3c64150.jpg";